
import React from 'react';

export const formatNumber = (num) => {
    /* if (!num || num == 'NaN') return '0';
    if (num == 'Infinity') return '&#x221e;';
    num = num.toString().replace(/\$|\,/g, '');
    if (isNaN(num))
        num = "0";
    let sign = (num == (num = Math.abs(num)));
    num = Math.floor(num * 100 + 0.50000000001);
    let cents = num % 100;
    num = Math.floor(num / 100).toString();
    if (cents < 10)
        cents = "0" + cents;

    let monto = 0;
    console.log(num);
    for (let i = 0; i < Math.floor((num.length - (1 + i)) / 3) ; i++){    console.log(Math.floor((num.length - (1 + i)) / 3));

        num = num.substring(0, num.length - (4 * i + 3)) + '.' + num.substring(num.length - (4 * i + 3));
        monto = (((sign) ? '' : '-') + num + ',' + cents);
    }

    return monto*/
    
    const formatter = new Intl.NumberFormat('es-VE', {
        style: 'currency',
        currency: 'VES',
        minimumFractionDigits: 0
    })

    return formatter.format(num).replace("Bs.S", "");
}

export const formatReconver = (cantidad, resta = 1000000) => {
    if (cantidad === 0) return cantidad;
    if (cantidad === null) return "";
    if (isNaN(cantidad)) return 0;
    return (cantidad / resta).toFixed(2)
}


// WEBPACK FOOTER //
// ./src/funciones/GeneralFunctions.jsx